import router from '../../../router'

export const storeUsers = {
    state: {
        status: 'idle',
        storePermissionsStatus: 'idle',
        storeUsersData: [],
        storePermissionsData: []
    },
    mutations: {
        SET_STORE_USERS_DATA(state, payload) {
            state.storeUsersData = payload
        },
        SET_STORE_USERS_STATUS(state, payload) {
            state.status = payload
        },
        SET_STORE_PERMISSIONS_DATA(state, payload) {
            state.storePermissionsData = payload
        },
        SET_STORE_PERMISSIONS_STATUS(state, payload) {
            state.storePermissionsStatus = payload
        }
    },
    actions: {
        storeUsersFetch({ state, commit, getters, dispatch }) {
            const userId = getters.userId
            if (state.status === 'idle') {
                commit('SET_STORE_USERS_STATUS', 'loading')

                this.$api
                    .get(`/users/${userId}/locationUser`)
                    .then(res => {
                        commit('SET_STORE_USERS_DATA', res.data.data.list)
                        commit('SET_STORE_USERS_STATUS', 'idle')
                    })
                    .catch(() => {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd'
                        })
                        commit('SET_STORE_USERS_STATUS', 'idle')
                    })
            }
        },
        storePermissionsFetch(
            { state, commit, getters, dispatch },
            locationUserId
        ) {
            const userId = getters.userId
            if (state.storePermissionsStatus === 'idle') {
                commit('SET_STORE_PERMISSIONS_STATUS', 'loading')
                return this.$api
                    .get(
                        `/users/${userId}/locationUser/${locationUserId}/locations`
                    )
                    .then(res => {
                        commit('SET_STORE_PERMISSIONS_DATA', res.data.data)
                        commit('SET_STORE_PERMISSIONS_STATUS', 'idle')
                        return res
                    })
                    .catch(() => {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd'
                        })
                        commit('SET_STORE_PERMISSIONS_STATUS', 'idle')
                    })
            }
        },
        addStoreUser({ state, commit, dispatch, getters }, payload) {
            const userId = getters.userId

            this.$api
                .post(`/users/${userId}/locationUser`, payload)
                .then(res => {
                    router.push({ name: 'store-users' })
                    dispatch(
                        'addNotification',
                        res.data.data.login
                            ? {
                                type: 'success',
                                content: `Użytkownik o loginie <b>${res.data.data.login}</b> został utworzony.<br/>
                               Dane można zmienić na liście użytkowników sklepowych.`,
                                duration: 10000
                            }
                            : {
                                type: 'danger',
                                content: 'Wystąpił błąd'
                            }
                    )
                })
                .catch(() => {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                })
        },
        editStoreUser({ state, commit, dispatch, getters }, payload) {
            const userId = getters.userId
            const isStoreChanged = payload.isStoreChanged
            delete payload.isStoreChanged
            this.$api
                .patch(`/users/${userId}/locationUser`, payload)
                .then(res => {
                    dispatch('toggleModal', false)
                    dispatch('storeUsersFetch')
                    if (res.status !== 200) throw res
                    if (res.status === 200) {
                        dispatch('addNotification', {
                            type: 'success',
                            content: isStoreChanged
                                ? 'Poprawnie zapisano dane. Zmiany będą widoczne w Panelu w przeciągu kilku minut.'
                                : 'Dane zostały zmienione.'
                        })
                    }
                })
                .catch(err => {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: err.response.data.message || 'Wystąpił błąd'
                    })
                })
        },
        deleteStoreUser({ dispatch, getters }, payload) {
            const userId = getters.userId

            this.$api
                .delete(`/users/${userId}/locationUser`, {
                    data: {
                        location_user_id: payload.location_user_id
                    }
                })
                .then(res => {
                    dispatch('toggleModal', false)
                    dispatch('storeUsersFetch')
                    if (res.status !== 200) throw res
                    if (res.status === 200) {
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Użytkownik został usunięty.'
                        })
                    }
                })
                .catch(err => {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: err.response.data.message || 'Wystąpił błąd'
                    })
                })
        }
    },
    getters: {
        getStoreUsers: state => {
            return state.storeUsersData
        },
        getStoreUsersStatus: state => {
            return state.status
        },
        getStorePermissionsStatus: state => {
            return state.storePermissionsStatus
        }
    }
}
